webpackJsonp([5],{

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cd1132a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(818), __esModule: true };

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(135);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userData: [],
      syncData: [],
      online: false,

      signupFormFields: {
        email: "",
        dashboard: 'Health Facility Survey'

      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    newInterest: function newInterest() {
      this.checkOnline();
      self = this;
      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LLLL');
      console.log(now);
      console.log(self.online);

      var payload = {
        email: this.signupFormFields.email,
        dashboard: this.signupFormFields.dashboard,
        created: now
      };
      if (self.online === true) {
        console.log(payload);
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://msdatapi.e4eweb.space/api/v1/subDashboardInterest/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)).then(function (response) {
          console.log(response);
          var res = response.status;
          if (res == 200 || res == 201) {
            self.signupFormFields.email = "";
            self.alertSuccess();
          } else {
            self.alertFailure();
          }
        });
      } else {
        this.$swal({
          icon: 'error',
          title: 'OOPs!!',
          text: 'Your seem to be ofline, please reconnect and try again',
          footer: ''
        });
      }
    },
    checkOnline: function checkOnline() {
      // var online = window.navigator.onLine;

      if (window.navigator.onLine === true) {
        this.online = true;
        console.log(this.online);
      } else {
        this.online = false;
        console.log(this.online);
      }
    },
    alertSuccess: function alertSuccess() {
      this.$swal({
        icon: 'success',
        title: 'Thank you',
        text: 'You will be the first to know when its out!',
        footer: ''

      });
    },
    alertFailure: function alertFailure() {
      this.$swal({
        icon: 'error',
        title: 'OOPs !!',
        text: 'There seem to be an error in your entry, please try again later!',
        footer: ''

      });
    }
  }
});

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, ".btn-outline-primary[data-v-cd1132a2]{border:2px solid #ff8f0f;color:#ff8f0f!important;font-weight:700;background-color:#fff!important;opacity:1;font-size:11px;font-family:Muli,sans-serif;cursor:default;height:30px}.btn-outline-primary[data-v-cd1132a2]:focus{outline:none}.btn-primary[data-v-cd1132a2]{color:#fff!important;font-weight:700;border:2px solid #ff8f0f!important;background-color:#ff8f0f!important;opacity:1;font-size:13px;font-family:Muli,sans-serif;text-transform:none!important;margin:0;height:41px;font-size:12px!important}.btn-primary[data-v-cd1132a2]:hover{color:#ff8f0f!important;background-color:#fff!important}.tittle[data-v-cd1132a2]{color:#232323!important;font-weight:700;background-color:#fff!important;opacity:1;line-height:55px;font-size:43px;font-family:Muli,sans-serif}.text-body[data-v-cd1132a2]{padding:4px;font-family:Muli,sans-serif}input[data-v-cd1132a2]{font-size:14px!important;font-family:Muli,sans-serif;height:42px}.msg[data-v-cd1132a2]{font-weight:400;color:#232323;font-family:Muli,sans-serif;font-size:16px}.msg2[data-v-cd1132a2]{font-weight:400;color:#5a5a5a;font-family:Muli,sans-serif;font-size:14px}.link-text[data-v-cd1132a2]{color:#007d53!important;font-weight:700;font-family:Muli,sans-serif;font-size:11px}.link-text a[data-v-cd1132a2]:hover{text-decoration:none!important}@media only screen and (max-width:1000px){#image[data-v-cd1132a2]{display:none}}@media only screen and (max-width:320px){#image[data-v-cd1132a2]{display:none}}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/healthFacilitySurvey.vue"],"names":[],"mappings":"AACA,sCACI,yBAA0B,AAC1B,wBAA2B,AAC3B,gBAAkB,AAClB,gCAAmC,AACnC,UAAW,AACX,eAAgB,AAChB,4BAAgC,AAChC,eAAgB,AAChB,WAAa,CAChB,AACD,4CACM,YAAc,CACnB,AACD,8BACI,qBAAwB,AACxB,gBAAkB,AAClB,mCAAoC,AACpC,mCAAqC,AACrC,UAAW,AACX,eAAgB,AAChB,4BAAgC,AAChC,8BAA+B,AAC/B,SAAY,AACZ,YAAa,AACb,wBAA2B,CAC9B,AACD,oCACI,wBAA2B,AAC3B,+BAAkC,CACrC,AACD,yBACI,wBAA2B,AAC3B,gBAAkB,AAClB,gCAAmC,AACnC,UAAW,AACX,iBAAkB,AAClB,eAAgB,AAChB,2BAAgC,CACnC,AACD,4BACI,YAAa,AACb,2BAAgC,CACnC,AACD,uBACI,yBAA2B,AAC3B,4BAAgC,AAChC,WAAa,CAChB,AACD,sBACI,gBAAmB,AACnB,cAAe,AACf,4BAAgC,AAChC,cAAgB,CACnB,AACD,uBACI,gBAAmB,AACnB,cAAe,AACf,4BAAgC,AAChC,cAAgB,CACnB,AACD,4BACI,wBAA0B,AAC1B,gBAAkB,AAClB,4BAAgC,AAChC,cAAgB,CACnB,AACD,oCACG,8BAAiC,CACnC,AAGD,0CACA,wBACQ,YAAc,CACrB,CACA,AAGD,yCACA,wBACQ,YAAc,CACrB,CACA","file":"healthFacilitySurvey.vue","sourcesContent":["\n.btn-outline-primary[data-v-cd1132a2]{\n    border: 2px solid #FF8F0F;\n    color:  #FF8F0F !important;\n    font-weight: bold;\n    background-color: white !important;\n    opacity: 1;\n    font-size: 11px;\n    font-family: 'Muli', sans-serif;\n    cursor: default;\n    height: 30px;\n}\n.btn-outline-primary[data-v-cd1132a2]:focus {\n      outline: none;\n}\n.btn-primary[data-v-cd1132a2]{\n    color:  #fff !important;\n    font-weight: bold;\n    border:2px solid #FF8F0F !important;\n    background-color: #FF8F0F !important;\n    opacity: 1;\n    font-size: 13px;\n    font-family: 'Muli', sans-serif;\n    text-transform: none!important;\n    margin: 0px;\n    height: 41px;\n    font-size: 12px !important;\n}\n.btn-primary[data-v-cd1132a2]:hover{\n    color:  #FF8F0F !important;\n    background-color: #fff !important;\n}\n.tittle[data-v-cd1132a2]{\n    color:  #232323 !important;\n    font-weight: bold;\n    background-color: white !important;\n    opacity: 1;\n    line-height: 55px;\n    font-size: 43px;\n    font-family: 'Muli', sans-serif;\n}\n.text-body[data-v-cd1132a2]{\n    padding: 4px;\n    font-family: 'Muli', sans-serif;\n}\ninput[data-v-cd1132a2]{\n    font-size: 14px !important;\n    font-family: 'Muli', sans-serif;\n    height: 42px;\n}\n.msg[data-v-cd1132a2]{\n    font-weight:normal;\n    color: #232323;\n    font-family: 'Muli', sans-serif;\n    font-size: 16px;\n}\n.msg2[data-v-cd1132a2]{\n    font-weight:normal;\n    color: #5A5A5A;\n    font-family: 'Muli', sans-serif;\n    font-size: 14px;\n}\n.link-text[data-v-cd1132a2]{\n    color: #007D53 !important;\n    font-weight: bold;\n    font-family: 'Muli', sans-serif;\n    font-size: 11px;\n}\n.link-text a[data-v-cd1132a2]:hover{\n   text-decoration: none !important;\n}\n  \n  /* Tablet ----------- */\n@media only screen and (max-width : 1000px) {\n#image[data-v-cd1132a2] {\n        display: none;\n}\n}\n\n/* Smartphones (portrait) ----------- */\n@media only screen and (max-width : 320px) {\n#image[data-v-cd1132a2] {\n        display: none;\n}\n}\n \n  \n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(911);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("731a7fc7", content, true, {});

/***/ }),

/***/ 977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-6"
  }, [_c('div', {
    staticClass: "bdy mt-5 ml-5 mr-5 left"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary ml-0 disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("COMING SOON")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('form', {
    staticClass: "mb-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.newInterest()
      }
    }
  }, [_c('div', {
    staticClass: "form-row  mt-4"
  }, [_c('div', {
    staticClass: "col-sm-7 pl-1 pr-0 pb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signupFormFields.email),
      expression: "signupFormFields.email"
    }],
    staticClass: "form-control ml-0",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Your e-mail address",
      "required": ""
    },
    domProps: {
      "value": (_vm.signupFormFields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.signupFormFields, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "link-text mt-4 mb-4 ml-1"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#007D53"
    },
    attrs: {
      "to": "/central_analytics"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Back to MSDAT")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 "
  }), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: " mt-3 mb-4 tittle"
  }, [_vm._v("Health Facility "), _c('br'), _vm._v(" Survey Dashboard")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-body  "
  }, [_c('p', {
    staticClass: "text-left msg"
  }, [_vm._v("This dashboard provides a single transparent view of data from health facilities across the country. By transparently visualizing data and trends, we intend improving the debate and focus on data quality and its use, so as to improve our overall understanding of key trends and progress within the health sector.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-body  mt-3"
  }, [_c('p', {
    staticClass: "text-left msg2"
  }, [_vm._v("This resource is currently not available. If you would like to be informed about its development, please leave your contact information below.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 pl-1"
  }, [_c('button', {
    staticClass: "btn btn-primary mb-2 pr-4 pl-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Keep me Updated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-12  bg-white right pr-0 pl-0",
    staticStyle: {
      "height": "80vh",
      "background": "url(static/img/subdashboards/)"
    },
    attrs: {
      "id": "image"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/img/subdashboards/healthfacility.jpg",
      "alt": "Health facility survey image"
    }
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.f1e84b046c812bd06cc3.js